<template>
    <div class="movie-performances-calendar position-relative">
        <div v-if="showSpinner" class="absolute-fill z-index-2 text-center cards-spinner">
            <i class="far fa-spinner-third fa-spin cards-spinner-icon"></i>
        </div>

        <div v-if="noResults" class="mt-5 text-center">
            Geen bioscopen gevonden op basis van je zoekcriteria
        </div>

        <h4 class="mt-5 color-brand--secondary" v-if="search">
            Gevonden bioscopen
        </h4>

        <movie-performances-row v-for="row in performanceRows.selected"
                                v-if="!search"
                                :key="'movie-performance-row-' + row.id"
                                :cinema-name="row.name"
                                :cinema-slug="row.slug"
                                :cinema-city="row.city ? row.city.name : ''"
                                :cinema-website="row.unserialized.website"
                                :times="row.unserializedPerformances.map(performance => ({
                                    day: performance.startDay,
                                    time: performance.startTime,
                                    ticketUrl: performance.ticketUrl,
                                }))"
                                :show-day-in-times="hasMinimumDayFilter">
        </movie-performances-row>

        <movie-performances-row v-for="row in performanceRows.other"
                                :key="'movie-performance-row-' + row.id"
                                :cinema-name="row.name"
                                :cinema-slug="row.slug"
                                :cinema-city="row.city ? row.city.name : ''"
                                :cinema-website="row.unserialized.website"
                                :times="row.unserializedPerformances.map(performance => ({
                                    day: performance.startDay,
                                    time: performance.startTime,
                                    ticketUrl: performance.ticketUrl,
                                }))"
                                :show-day-in-times="hasMinimumDayFilter">
        </movie-performances-row>
    </div>
</template>

<script>

    export default {
        props: {
            movieId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                showSpinner: true,
                noResults: false,
                eventName: 'movie_performances_calendar_filter',
                performanceRows: {
                    selected: [],
                    other: [],
                },
                searchValue: null,
                notInSelectedCinemas: false,
                searchByFilters: null,
                location: {},
                search: false,
                hasMinimumDayFilter: false,
                ajaxUrl: '/ajax/movie-calendar-performances'
            };
        },
        mounted() {

            // Set the movie ID
            MrMovie.pageFilter.removeFilters('movieId');
            MrMovie.pageFilter.addFilters('movieId', [this.movieId]);

            if(MrMovie.geolocation.getLocationFromSession() && window.location.href.indexOf('city=') <= 0 && window.location.href.indexOf('search=') <= 0) {
                VueEvents.$emit('location:triggered');
            }

            // // Hide the spinner and 'no results' text, when values have changed
            VueEvents.$on('loaded_cinemas', (response) => {
                this.showSpinner = false;
                this.noResults = false;

                // Check if there are any performances
                const selectedCount = (response.selected) ? response.selected.length : 0;
                const otherCount = (response.other) ? response.other.length : 0;
                if (selectedCount === 0 && otherCount === 0) {
                    this.noResults = true;
                    this.performanceRows = {
                        selected: [],
                        other: [],
                    };
                    return;
                }

                this.performanceRows = response;

                // Decide to show the notification
                this.notInSelectedCinemas = (! response.selected.length);

                this.search = false;
                if(typeof MrMovie.pageFilter.getFilters('search') !== 'undefined') {
                    this.search = true;
                }

                if(MrMovie.pageFilter.getFilters('day')) {
                    this.hasMinimumDayFilter = (MrMovie.pageFilter.getFilters('day').getValues()[0].match(/\+$/) !== null);
                }
            });
        },
        methods: {

            getMoviePerformances(activeFilters) {

                let args = {};
                for(let activeFilter of activeFilters) {
                    args[activeFilter.id] = activeFilter.values.join(',');
                }

                let promise = this.doRequest(args);

                promise.then(response => {


                }, this);
            },

            doRequest(callArgs) {

                let promise =  $.get(this.ajaxUrl, callArgs);

                this.lock = true;

                promise.then(response => {
                    this.lock = false;
                }, self);

                return promise;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/single/MoviePerformancesCalendar.vue